import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PendingLeavesService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiBaseUrl}/`;

  constructor() { }

  confirmPendingLeaves = (id: string, accept: boolean) => {
    return this.http.put(this.baseUrl + `activities/${id}/${accept ? 'acceptance' : 'rejection'}`, {})
  }

}
